<header *ngIf="isHeader">
  <div class="container">
    <nav>
      <ul>
        <li (click)="redirectBack()" [class.ml-10]="textDirection == 'rtl'">
          <img src="assets/images/close-icon.svg" class="close-icon" alt="close-img" >
          <span translate  class="back-to-store">COMMON.BACK_TO_STORE</span>
        </li>
        <li>
          <div class="payment-with">
            <img src="assets/images/lock-icon.svg" alt="Lock-icon" >
            <span translate> PAYMENT_WITH</span>
            <img src="assets/images/taly-dark-icon.svg" alt="Taly-logo" >
          </div>
        </li>
        <li [class.mr-15]="textDirection == 'rtl'">
          <div class="language" (click)="toggleText()">
            <img src="assets/images/lang-icons-black.svg" alt="">
            <label for="lang" translate> LANGUAGE</label>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</header>